import { useEffect } from 'react';
import { useUIStore, type Theme } from '@/stores/uiStore';

export function useTheme() {
  const theme = useUIStore((s) => s.theme);
  const setTheme = useUIStore((s) => s.setTheme);

  useEffect(() => {
    document.documentElement.setAttribute(
      'data-theme',
      theme === 'dark' ? '' : theme
    );
  }, [theme]);

  const toggle = () => {
    // Cycle through: dark → light → aurora → dark
    const next = theme === 'dark' ? 'light' : theme === 'light' ? 'aurora' : 'dark';
    setTheme(next);
  };

  return { theme, setTheme, toggle } as const;
}

export function useThemeValue(): Theme {
  return useUIStore((s) => s.theme);
}
